var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',{staticClass:"back-button p-button-link",on:{"click":_vm.goBack}},[_c('div',{staticClass:"icon-back"}),_c('span',[_vm._v(_vm._s(_vm.$t("notifications.btn_back")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }